import React, { useEffect, useState } from "react"

import { Link, NavLink } from "react-router-dom"

import { ReactComponent as CluxLogo } from "../../assets/logo.svg"
import { ROUTES } from "../../config/routes"
import { PAGES, PageKey } from "../../enums/pages"
import { HEADER_VARIANTS } from "../../enums/variants"

import "./style.scss"

type NavLinkConfig = {
  page: PageKey
  label: string
  color: "pink" | "yellow" | "blue" | "green"
}

const NAV_LINKS: NavLinkConfig[] = [
  { page: PAGES.ATELIERS, label: "Les ateliers", color: "pink" },
  { page: PAGES.MATERIEL, label: "Le matériel", color: "yellow" },
  { page: PAGES.OUTILS, label: "Les outils", color: "blue" },
  { page: PAGES.BLOG, label: "Le blog", color: "green" },
]

const Header = ({ headerVariant }: { headerVariant: HEADER_VARIANTS }) => {
  const [scrolled, setScrolled] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50)
    }

    handleScroll()
    window.addEventListener("scroll", handleScroll, { passive: true })
    return () => window.removeEventListener("scroll", handleScroll)
  }, [])

  return (
    <header
      className={`header-container variant-${headerVariant}${
        scrolled ? " scrolled" : ""
      }`}
    >
      <div className="header-background" />
      <div className="header-content">
        <Link
          to={ROUTES[PAGES.HOME].path}
          className="header-logo"
          aria-label="Accueil"
        >
          <CluxLogo />
        </Link>
        <nav aria-label="Navigation principale">
          <ul className="header-nav">
            {NAV_LINKS.map(({ page, label, color }) => (
              <li key={page}>
                <NavLink
                  to={ROUTES[page].path}
                  className={`header-nav-link color-${color}`}
                >
                  <span className="header-nav-label">{label}</span>
                  <span className="header-nav-underline" aria-hidden />
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </header>
  )
}

export default Header
